import { Stack, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { AccountInfoLabel, ClockIcon } from '@woovi/ui';
import { convertToMoney } from '@woovi/utils';

import type { PaymentMethodCreditCardSelectedProcessing_charge$key } from './__generated__/PaymentMethodCreditCardSelectedProcessing_charge.graphql.ts';
import PaymentLinkAdditionalInfo from '../../paymentLink/PaymentLinkAdditionalInfo.tsx';
import PaymentLinkComment from '../../paymentLink/PaymentLinkComment.tsx';
import PaymentLinkTransactionDetails from '../../PaymentLinkTransactionDetails.tsx';

type PaymentMethodCreditCardSelectedProcessingProps = {
  charge: PaymentMethodCreditCardSelectedProcessing_charge$key;
};

const PaymentMethodCreditCardSelectedProcessing = (
  props: PaymentMethodCreditCardSelectedProcessingProps,
): ReactNode => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const charge =
    useFragment<PaymentMethodCreditCardSelectedProcessing_charge$key>(
      graphql`
        fragment PaymentMethodCreditCardSelectedProcessing_charge on Charge {
          id
          brCode
          identifier
          company {
            nameFriendly
            logo {
              url(fitIn: true)
            }
            projectType
            taxID {
              taxID
            }
          }
          valueWithDiscount
          ...PaymentLinkComment_charge
          ...PaymentLinkAdditionalInfo_charge
          ...PaymentLinkTransactionDetails_charge
        }
      `,
      props.charge,
    );

  return (
    <Stack alignItems='center' gap={2}>
      <ClockIcon size={isMobile ? 60 : undefined} />
      <Typography
        variant={isMobile ? 'h5' : 'h4'}
        fontWeight='bold'
        sx={{ textAlign: { xs: 'center' } }}
      >
        {t('Processing Payment')}
      </Typography>
      <PaymentLinkComment charge={charge} />
      <AccountInfoLabel
        label={t('Value')}
        text={convertToMoney(charge.valueWithDiscount)}
      />
      <Stack>
        {/*<PaymentLinkPaymentTerm charge={charge} />*/}
        <PaymentLinkTransactionDetails charge={charge} />
        <PaymentLinkAdditionalInfo charge={charge} />
      </Stack>
    </Stack>
  );
};

export default PaymentMethodCreditCardSelectedProcessing;
